import {interact} from 'fire-wind-water';

let config = window.stemplateConfig || {};

export function isLink() {
  const url = `//${window.location.host}${window.location.pathname}`;
  const href = window.location.href;
  let link = '';
  if (config.link && config.link.pc && config.link.wap) {
    if (interact.isMobile === 1) {
      link = config.link.wap;
    } else {
      link = config.link.pc;
    }
  }
  if (link && href !== link && url !== link && href.indexOf(link) === -1) {
    window.location.href = link + window.location.search;
  }
}